import { NavLink, useNavigate } from 'react-router-dom';
import {
  GlobeAltIcon,
  ArrowUpTrayIcon,
  FilmIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { authService } from '@/services/auth';

const navItems = [
  { to: '/discover', label: 'Discover', icon: GlobeAltIcon },
  { to: '/upload', label: 'Upload', icon: ArrowUpTrayIcon },
  { to: '/studio', label: 'Studio', icon: FilmIcon },
  { to: '/settings', label: 'Settings', icon: Cog6ToothIcon },
];

function UserTierBadge() {
  const user = authService.getUser();
  if (!user) return null;
  const isPro = user.tier === 'pro';
  return (
    <div className="px-3 py-2">
      <p className="text-xs text-text-tertiary truncate">{user.email}</p>
      <span className={`inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-xs font-semibold ${
        isPro
          ? 'bg-accent/15 text-accent border border-accent/30'
          : 'bg-midnight-surface text-text-tertiary border border-midnight-border'
      }`}>
        {isPro ? 'Pro' : 'Free'}
      </span>
    </div>
  );
}

export default function Sidebar() {
  const navigate = useNavigate();

  const handleSignOut = () => {
    authService.clearAuth();
    navigate('/login');
  };

  return (
    <aside className="fixed top-0 left-0 bottom-0 w-64 bg-midnight-bg border-r border-midnight-border flex flex-col z-40">
      {/* Logo */}
      <div className="h-16 flex items-center px-6 border-b border-midnight-border">
        <a href="/" className="flex items-center gap-2">
          <img src="/icon-32.png" alt="VideoQR" className="w-7 h-7 rounded-md" />
          <span className="text-xl font-bold text-accent">VideoQR</span>
        </a>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-accent/10 text-accent'
                  : 'text-text-secondary hover:text-white hover:bg-midnight-surface'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* User Info + Sign Out */}
      <div className="p-3 border-t border-midnight-border space-y-2">
        <UserTierBadge />
        <button
          onClick={handleSignOut}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-text-secondary hover:text-white hover:bg-midnight-surface transition-colors"
        >
          <ArrowRightOnRectangleIcon className="w-5 h-5" />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
